import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';

import CloseIcon from '@mui/icons-material/Close';
import { Typography } from '@mui/material';

export default function CustomDialog({ title, open = true, onClose, children, buttons, ...rest }) {
  const contentRef = React.useRef(null);

  React.useEffect(() => {
    if (open) {
      const { current: content } = contentRef;
      if (content !== null) {
        content.focus();
      }
    }
  }, [open]);

  return (
    <Dialog
      onClose={onClose}
      disableEscapeKeyDown={!onClose}
      open={open}
      {...rest}
    >
      {(title || onClose) && (
        <DialogTitle display="flex" justifyContent="space-between">
          <Typography variant="button">
            {title}
          </Typography>
          {onClose ? (
            <IconButton
              edge="end"
              onClick={onClose}
              aria-label="close"
              sx={{ marginTop: -1, marginBottom: -1 }}
            >
              <CloseIcon  color="action" />
            </IconButton>
          ) : null}
        </DialogTitle>
      )}
      <DialogContent ref={contentRef} dividers={rest.scroll === 'paper'}>
        {children}
      </DialogContent>
      {buttons && (
        <DialogActions>
          {buttons}
        </DialogActions>
      )}
    </Dialog>
  );
}
